// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/engine/v1/sandbox_engine_template_service.proto (package ai.h2o.engine.v1, syntax proto3)
/* eslint-disable */

import type { SandboxEngineTemplate } from "./sandbox_engine_template_pb";
import { RPC } from "../../../../runtime";

/**
 * Request message for `CreateSandboxEngineTemplate`.
 *
 * @generated from message ai.h2o.engine.v1.CreateSandboxEngineTemplateRequest
 */
export type CreateSandboxEngineTemplateRequest = {
/**
 * Required. The resource name of the workspace to associate with the SandboxEngineTemplate.
 * Format is `workspaces/*`.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Required. The SandboxEngineTemplate resource to create.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_template = 2;
 */
sandboxEngineTemplate: SandboxEngineTemplate;
/**
 * Optional. Specify the SandboxEngineTemplate ID, which will become a part of the SandboxEngineTemplate
 * resource name. If not specified, the server will generate one.
 *
 * It must:
 * - contain 1-63 characters
 * - contain only lowercase alphanumeric characters or hyphen ('-')
 * - start with an alphabetic character
 * - end with an alphanumeric character
 *
 * This matches a regular expression: ^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$
 *
 * @generated from field: string sandbox_engine_template_id = 3;
 */
sandboxEngineTemplateId?: string;
}
;
/**
 * Response message for `CreateSandboxEngineTemplate`.
 *
 * @generated from message ai.h2o.engine.v1.CreateSandboxEngineTemplateResponse
 */
export type CreateSandboxEngineTemplateResponse = {
/**
 * The created SandboxEngineTemplate.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_template = 1;
 */
sandboxEngineTemplate?: SandboxEngineTemplate;
}
;
/**
 * Request message for `GetSandboxEngineTemplate`.
 *
 * @generated from message ai.h2o.engine.v1.GetSandboxEngineTemplateRequest
 */
export type GetSandboxEngineTemplateRequest = {
/**
 * Required. The name of the SandboxEngineTemplate to retrieve.
 * Format is `workspaces/*\/sandboxEngineTemplates/*`
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for `GetSandboxEngineTemplate`.
 *
 * @generated from message ai.h2o.engine.v1.GetSandboxEngineTemplateResponse
 */
export type GetSandboxEngineTemplateResponse = {
/**
 * The requested SandboxEngineTemplate.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_template = 1;
 */
sandboxEngineTemplate?: SandboxEngineTemplate;
}
;
/**
 * Request message for listing SandboxEngineTemplates.
 *
 * @generated from message ai.h2o.engine.v1.ListSandboxEngineTemplatesRequest
 */
export type ListSandboxEngineTemplatesRequest = {
/**
 * Required. The resource name of the workspace to associate with the SandboxEngineTemplate.
 * Format is `workspaces/*`.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Optional. Maximum number of SandboxEngineTemplates to return in a response.
 * If unspecified (or set to 0), at most 50 SandboxEngineTemplates will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Optional. Leave unset to receive the initial page.
 * To list any subsequent pages use the value of 'next_page_token'
 * returned from the ListSandboxEngineTemplatesResponse.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
}
;
/**
 * Response message for ListSandboxEngineTemplates.
 *
 * @generated from message ai.h2o.engine.v1.ListSandboxEngineTemplatesResponse
 */
export type ListSandboxEngineTemplatesResponse = {
/**
 * Collection of SandboxEngineTemplates.
 *
 * @generated from field: repeated ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_templates = 1;
 */
sandboxEngineTemplates?: SandboxEngineTemplate[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for updating an existing SandboxEngineTemplate.
 *
 * @generated from message ai.h2o.engine.v1.UpdateSandboxEngineTemplateRequest
 */
export type UpdateSandboxEngineTemplateRequest = {
/**
 * Required. SandboxEngineTemplate resource.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_template = 1;
 */
sandboxEngineTemplate: SandboxEngineTemplate;
/**
 * Required. The list of paths referencing which fields to update.
 * Update mask must be non-empty.
 *
 * Allowed field paths are: {"display_name", "milli_cpu_request", "milli_cpu_limit", "gpu_resource", "gpu", "memory_bytes_request", "memory_bytes_limit", "storage_bytes", "storage_class_name", "environmental_variables", "yaml_pod_template_spec", "enabled", "max_idle_duration"}.
 * Paths are case sensitive (must match exactly).
 *
 * To update all allowed fields, specify exactly one path with value "*".
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 10;
 */
updateMask: string;
}
;
/**
 * Response message for UpdateSandboxEngineTemplate.
 *
 * @generated from message ai.h2o.engine.v1.UpdateSandboxEngineTemplateResponse
 */
export type UpdateSandboxEngineTemplateResponse = {
/**
 * SandboxEngineTemplate resource.
 *
 * @generated from field: ai.h2o.engine.v1.SandboxEngineTemplate sandbox_engine_template = 1;
 */
sandboxEngineTemplate?: SandboxEngineTemplate;
}
;
/**
 * Request message for deleting an existing SandboxEngineTemplate.
 *
 * @generated from message ai.h2o.engine.v1.DeleteSandboxEngineTemplateRequest
 */
export type DeleteSandboxEngineTemplateRequest = {
/**
 * Required. SandboxEngineTemplate resource name.
 * Format is `workspaces/*\/sandboxEngineTemplates/*`.
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteSandboxEngineTemplate.
 *
 * @generated from message ai.h2o.engine.v1.DeleteSandboxEngineTemplateResponse
 */
export type DeleteSandboxEngineTemplateResponse = {
}
;
/**
 * Creates a new SandboxEngineTemplate.
 *
 * Authorization may require the following permission on the template's parent workspace:
 * * actions/enginemanager/sandboxEngineTemplates/CREATE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineTemplateService.CreateSandboxEngineTemplate
 */
export const SandboxEngineTemplateService_CreateSandboxEngineTemplate = new RPC<CreateSandboxEngineTemplateRequest,CreateSandboxEngineTemplateResponse>("POST", "/v1/{parent=workspaces/*}/sandboxEngineTemplates", "sandboxEngineTemplate");
/**
 * Returns a specific SandboxEngineTemplate.
 *
 * Authorization may require the following permission on the template's parent workspace:
 * * actions/enginemanager/sandboxEngineTemplates/GET
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineTemplateService.GetSandboxEngineTemplate
 */
export const SandboxEngineTemplateService_GetSandboxEngineTemplate = new RPC<GetSandboxEngineTemplateRequest,GetSandboxEngineTemplateResponse>("GET", "/v1/{name=workspaces/*/sandboxEngineTemplates/*}");
/**
 * Returns a collection of SandboxEngineTemplates.
 *
 * Authorization may require the following permission on the template's parent workspace:
 * * actions/enginemanager/sandboxEngineTemplates/LIST
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineTemplateService.ListSandboxEngineTemplates
 */
export const SandboxEngineTemplateService_ListSandboxEngineTemplates = new RPC<ListSandboxEngineTemplatesRequest,ListSandboxEngineTemplatesResponse>("GET", "/v1/{parent=workspaces/*}/sandboxEngineTemplates");
/**
 * Updates a SandboxEngineTemplate.
 *
 * Authorization may require the following permission on the template's parent workspace:
 * * actions/enginemanager/sandboxEngineTemplates/UPDATE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineTemplateService.UpdateSandboxEngineTemplate
 */
export const SandboxEngineTemplateService_UpdateSandboxEngineTemplate = new RPC<UpdateSandboxEngineTemplateRequest,UpdateSandboxEngineTemplateResponse>("PATCH", "/v1/{sandboxEngineTemplate.name=workspaces/*/sandboxEngineTemplates/*}", "sandboxEngineTemplate");
/**
 * Deletes a SandboxEngineTemplate.
 *
 * Authorization may require the following permission on the template's parent workspace:
 * * actions/enginemanager/sandboxEngineTemplates/DELETE
 *
 * @generated from rpc ai.h2o.engine.v1.SandboxEngineTemplateService.DeleteSandboxEngineTemplate
 */
export const SandboxEngineTemplateService_DeleteSandboxEngineTemplate = new RPC<DeleteSandboxEngineTemplateRequest,DeleteSandboxEngineTemplateResponse>("DELETE", "/v1/{name=workspaces/*/sandboxEngineTemplates/*}");
